import React, { FC } from 'react';
import { Styled } from './styled';
type DotsProps = {
  slidesCount: number;
  currentSlide: number;
  className?: string;
  variant?: 'default' | 'premiumBanking';
};
export const Dots: FC<DotsProps> = ({
  currentSlide,
  slidesCount,
  className,
  variant
}) => <Styled.DotsContainer data-testid="Carousel_Dots" className={className} slidesCount={slidesCount}>
    {Array.from({
    length: slidesCount
  }, (_, idx) => <Styled.Dot active={idx === currentSlide} key={idx} variant={variant} />)}
  </Styled.DotsContainer>;
Dots.defaultProps = {
  variant: 'default'
};